import type { FaceConfig } from "facesjs";
import { MyFace } from "./MyFace.tsx";
import i18n from "../util/i18n.ts";

const imgStyle = {
	maxHeight: "100%",
	maxWidth: "100%",
};

export const PlayerPicture = ({
	colors,
	face,
	imgURL,
	jersey,
	lazy,
}: {
	colors?: [string, string, string];
	face?: FaceConfig;
	imgURL?: string;
	jersey?: string;
	lazy?: boolean;
}) => {
	if (imgURL) {
		return (
			<img
				alt={i18n.t("common.player", { ns: "ui", defaultValue: "Player" })}
				src={imgURL}
				style={imgStyle}
			/>
		);
	}

	if (face) {
		return <MyFace colors={colors} face={face} jersey={jersey} lazy={lazy} />;
	}

	return null;
};
